import router from "./router";
import i18n from "./i18n";

export const dataModuleRouter = router;
export const dataModuleI18n = i18n;
